import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfStock } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfStock = {
	NOME: '',
	ORGAOUNIDADE: '',
	ORGAO: '',
	TRAMITARPROPRIAUNIDADE: 1,
};

export const useListStocksController = () => {
	const [stocksData, setStocksData] = useState<ModelOfStock[]>([]);
	const [selectedStock, setSelectedStock] = useState<ModelOfStock>(initialValuesOfStock);
	const [loading, setLoading] = useState(true);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		NOME: Yup.string().required('* Campo obrigatório'),
		ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
	});

	const getStocks = () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post('stocks2', { ROW: rows })
			.then(response => {
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setStocksData(
						stocksData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeStock = (stock: ModelOfStock) => {
		setLoading(true);
		api.delete(`stocks/${stock.ID}`)
			.then(response => {
				const newList = stocksData.filter(stock => stock.ID !== response.data.ID);
				setStocksData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O estoque foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getStocks();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editStock = (stock: ModelOfStock) => {
		setLoadingEdit(true);

		const editedStock: ModelOfStock = {
			...stock,
			ORGAO: userAgencyId,
			TRAMITARPROPRIAUNIDADE: 1,
		};

		api.put(`stocks/${selectedStock?.ID}`, editedStock)
			.then(() => {
				// getStocks();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O estoque foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getStocks();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getStocks();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rows]);

	const openDeleteDialog = (stock: ModelOfStock) => {
		setDeleteDialog(true);
		setSelectedStock(stock);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (stock: ModelOfStock) => {
		setEditDialog(true);
		setSelectedStock(stock);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfStock>({
		initialValues: {
			ORGAOUNIDADE: '',
			ORGAO: '',
			NOME: '',
			TRAMITARPROPRIAUNIDADE: 1,
		},
		onSubmit: async values => await editStock(values),
		validationSchema,
	});

	return {
		getStockListController: {
			formik,
			stocksData,
			selectedStock,
			loading,
			loadingEdit,
			deleteDialog,
			editDialog,
			toast,
			rows,
			maxData,
			loadingRows,
		},
		handleStockListController: {
			removeStock,
			editStock,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
